export { default } from './AllInclusiveCard';
